
import { ArrowCircleRightSharp } from '@mui/icons-material';
import { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useParams, useRouteMatch } from "react-router-dom";
import Scroll from 'react-scroll';
import ConnUrls from '../../Connections/ConnectURL';
import { CurrentPContext, MasterContext, MobiOrNotContext, OrderContext } from '../../ContextApi/context';
import Delivery_Confirmd from '../../DTechComp/Pop_Fixed/Delivery_Confirmd';
import TAKE_Confirmd from '../../DTechComp/Pop_Fixed/TAKE_Confirmd';
import ScrollingSaver from '../../DTechComp/ScrollingSaver';
import OrderFunctions from '../../OrderSettings/OrderFunctions';
import utilsSingleP from '../../_Utils/utilsSinglePage';
import myFunctions from '../../myFunctions';
import { Helmet } from 'react-helmet';
import utilsOrders from '../../_Utils/utilsOrders';
import WaitImgOverlay from '../../DTechComp/WaitImgOverlay';

var scroller = Scroll.scroller;
var scroll = Scroll.animateScroll;

const ThankPage = (props) => {

  const currentUrl = window.location.href;
  const urlObject = new URL(currentUrl);
  const domain = urlObject.origin;

  const [order, setOrder] = useContext(OrderContext);

  const [master, setMaster] = useContext(MasterContext);

  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const [loading, setLoading] = useState(true);
  const [waitImgItm, setWaitImgItm] = useState({});
  const [bkparams, setBkparams] = useState();
  const [thePopUp, setThePopUp] = useState("");
  const [thankDataReady, setThankDataReady] = useState(false);

  // כמה זמן פופאפ "ההזמנה בוצעה" יוצג לפחות לפני ניווט אוטומטי החוצה.
  // הלקוח יכול תמיד ללחוץ "המשך" ולעבור מייד; אם לא לחץ - עוברים לבד.
  const AUTO_CONTINUE_MS = 5000;
  const autoContinueTimer = useRef(null);
  const navigatedOut = useRef(false);

  let { path, url } = useRouteMatch();

  const history = useHistory();
  const params = useParams();

  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  }

  useEffect(() => {


    //currentPage עדיין של העמוד הקודם, ולכן חישוב ממנו הציג לרגע תמונה זרה (בד"כ של המאסטר).
    //התמונה נקבעת כשנתוני העמוד מגיעים; עד אז נשאר מסך לבן.
    if (master?.imgWaitingActive === false) setWaitImgItm({ active: false });

    props.shoTopStrp(false)
    getSinglePage();
    getParmeters();   // בונה את הפופאפ בעצמה כשהנתונים האמיתיים מהשרת מגיעים
    setLoading(false);


  }, [])

  // ניקוי הטיימר בעת פירוק הרכיב
  useEffect(() => {
    return () => {
      if (autoContinueTimer.current) clearTimeout(autoContinueTimer.current);
    };
  }, [])

  // עמוד התודה נטען בתוך ה-iframe של קארדקום, ולכן צריך לנווט את חלון האב.
  // כתובת מלאה ולא יחסית — כתובת יחסית נפתרת מול המסמך של ה-iframe.
  // אם הניווט של האב נחסם (חוסר התאמת דומיין / הרשאות), לא נשארים תקועים
  // על החלון אלא מנווטים לפחות את המסגרת הנוכחית.
  // מוגן מפני קריאה כפולה (טיימר האוטו-המשך + לחיצת "המשך" של המשתמש).
  const goOutsidOfframe = () => {
    if (navigatedOut.current) return;
    navigatedOut.current = true;
    if (autoContinueTimer.current) {
      clearTimeout(autoContinueTimer.current);
      autoContinueTimer.current = null;
    }

    const target = `${ConnUrls.siteDomainNam}/MyOrders`;

    try {
      if (window.parent && window.parent !== window) {
        window.parent.location.href = target;
        return;
      }
    } catch (e) {
      // ניווט חלון האב נחסם — ממשיכים ל-fallback
    }

    setThePopUp();

    try {
      history.push("/MyOrders");
    } catch (e) {
      window.location.href = target;
    }
  }


  const setPopUp = (theOrder) => {
    const src = theOrder || order;

    // מיידע את ההורה שהתשלום אושר בפועל מול ה-DB - מנקה שם את הסל ומסתיר
    // את כפתור ה-X של הפופאפ, כך שאם המשתמש סוגר את ה-iframe לפני שלוחץ
    // "המשך" כאן, לא נשארת לו הזדמנות ליצור הזמנה נוספת על אותו סל
    if (window.parent && window.parent !== window) {
      window.parent.parentOrderBridge?.notifyOrderSuccess();
    }

    if (src.OrderType == "Take") {
      setThePopUp(
        <TAKE_Confirmd order={src}
          okClick={() => { OrderFunctions.clearOrd(); goOutsidOfframe() }}
        />
      )

    }
    else {
      setThePopUp(
        <Delivery_Confirmd order={src}
          okClick={() => { OrderFunctions.clearOrd(); goOutsidOfframe() }}
        />
      )
    }

    // הפופאפ יוצג לפחות AUTO_CONTINUE_MS; אם הלקוח לא לחץ "המשך" עד אז -
    // מנווטים החוצה בעצמנו (במקום הניתוב האוטומטי המוקדם שהיה ב-onPopState
    // של TheOrderList ולפעמים העיף את הלקוח לפני שהספיק לראות את האישור).
    if (autoContinueTimer.current) clearTimeout(autoContinueTimer.current);
    autoContinueTimer.current = setTimeout(() => {
      OrderFunctions.clearOrd();
      goOutsidOfframe();
    }, AUTO_CONTINUE_MS);
  }

  // מעדיף את creditCrdApprov הטרי מה-DB על פני פרמטר ה-URL; אם עדיין ריק והתשלום הוא אשראי
  // (לא מזומן) — מנסה שוב עד 2 פעמים נוספות (כל 2 שנ'), נותן ל-webhook של קארדקום זמן להגיע.
  const fetchOrderWithRetry = async (orderNumber, urlApprovalNumber, attempt = 1) => {
    let ordBack = await utilsOrders.getOrderSmallOrder(orderNumber);
    if (!ordBack.creditCrdApprov) {
      ordBack.creditCrdApprov = urlApprovalNumber;
    }
    if (!ordBack.creditCrdApprov && ordBack.payt !== "2" && attempt < 3) {
      await new Promise(res => setTimeout(res, 2000));
      return fetchOrderWithRetry(orderNumber, urlApprovalNumber, attempt + 1);
    }
    return ordBack;
  }

  const getParmeters = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams) {
      let prms = {
        orderNumber: urlParams.get('orderNumber'),
        approvalNumber: urlParams.get('approvalNumber'),
      }

      let ordBack = await fetchOrderWithRetry(prms.orderNumber, prms.approvalNumber);

      setOrder(ordBack)

      setBkparams(prms);

      setPopUp(ordBack);

      setThankDataReady(true);

    }
    else {
      history.push("/404")
    }
  }

  const getSinglePage = async () => {
    let pName = props.pageName || window.document.href.substring(window.document.href.lastIndexOf('/') + 1)
    let theSingle = await utilsSingleP.getPageByName(props.pageName);
    setWaitImgItm(myFunctions.setTheImgWait(theSingle, master, mobiOrNot));
    setCurrentPage({ ...theSingle, pageTYp: "" });

  }
  const goToBack = () => {
    sessionStorage.setItem("SinglePage", "");
    history.goBack();

  }

  const setBackground = () => {

    if (window.parent !== window) {
      const elements = document.querySelectorAll('.popDiagBlock > div');

      elements.forEach((element) => {
        element.style.backgroundColor = 'white';
      });

      const inelements = document.querySelectorAll('.popDiagBlock .MuiPaper-root');

      inelements.forEach((element) => {
        element.style.boxShadow = 'unset';
      });
    }
  }

  return (
    <div className="SinglePage">
      <WaitImgOverlay item={waitImgItm} ready={thankDataReady && !!waitImgItm?.active} />

      {!thankDataReady ? "" :
        <>
          {(mobiOrNot) ?
            <>
              <div className={"headOnFixC SecondFont bold big"}>
                <div className={`backSdOnlyBtn`}>
                  <ArrowCircleRightSharp onClick={() => goToBack()} />
                </div>
              </div>
              <div className={`singlePagePad`}>
              </div>
            </>
            :
            ""

          }

          <ScrollingSaver pagNam={"ThankPage"} />

          {thePopUp}
          {setBackground()}
        </>

      }

      <Helmet
        meta={[
          {
            property: "og:url", content: `${ConnUrls.siteDomainNam}/${encodeURIComponent(currentPage.inLinkToPage)}`
          }
        ]}>
        <link rel="canonical" href={`${ConnUrls.siteDomainNam}/${encodeURIComponent(currentPage.inLinkToPage)}`} />
      </Helmet>
    </div>
  );
}

export default ThankPage;
